var Rm5ExportTableCell, getCellFootnotes, rm5ExportConfig, rm5TbodyCells;

rm5ExportConfig = require('lib/rm5_export_config');

getCellFootnotes = require('lib/rm5export/rm5_export_utils').getCellFootnotes;

rm5TbodyCells = rm5ExportConfig.tbodyCells;

Rm5ExportTableCell = rm5ExportConfig.Rm5ExportTableCell;

module.exports = function(attributes, tableMode) {
  var calculateColspan, cellData, cellName, cellNotes, colspan, outcomeHasFootnotes, outcomeRow, placeholder, rowSchema, tableType, tableView, _ref;
  if (tableMode == null) {
    tableMode = 'regular';
  }
  tableView = attributes.tableView;
  tableType = "" + tableView + "_" + tableMode;
  rowSchema = rm5ExportConfig.theadSchemas[tableType][0];
  outcomeRow = {
    cells: []
  };
  outcomeHasFootnotes = !_(attributes.footnotes).isEmpty();
  for (cellName in rowSchema) {
    placeholder = (_ref = cellName.match(/\[[a-z]+\]/)) != null ? _ref[0] : void 0;
    cellName = cellName.replace(placeholder, '');
    if (cellName === 'absoluteEffect') {
      colspan = tableView === 'sof_v3' || tableView === 'sof_v4' ? 4 : 2;
      if (outcomeHasFootnotes) {
        cellNotes = getCellFootnotes('impact', attributes.footnotes);
      }
      cellData = {
        textContent: _.unescape(rm5TbodyCells['impact'](attributes)),
        colspan: colspan,
        name: 'impact'
      };
      if (cellNotes) {
        cellData.sup = cellNotes;
      }
      outcomeRow.cells.push(new Rm5ExportTableCell(cellData));
    } else if (cellName === 'relativeEffect') {
      if (tableView === 'sof_v3' || tableView === 'sof_v4') {
        continue;
      }
      calculateColspan = function(cellName, tableView, tableMode) {
        if (tableMode === 'narrative') {
          return 1;
        }
        if (tableView === 'sof_short' && cellName === 'impact') {
          return 4;
        } else {
          return 1;
        }
      };
      cellName = tableView === 'sof_short' ? 'impact' : cellName;
      colspan = calculateColspan(cellName, tableView, tableMode);
      if (outcomeHasFootnotes) {
        cellNotes = getCellFootnotes(cellName, attributes.footnotes);
      }
      outcomeRow.cells.push(new Rm5ExportTableCell({
        textContent: rm5TbodyCells[cellName](attributes),
        sup: cellNotes || '',
        name: cellName,
        colspan: colspan
      }));
    } else {
      if (tableView === 'sof_short' && (cellName === 'sofControl' || cellName === 'correspondingRisk' || cellName === 'riskDifference')) {
        continue;
      }
      if (outcomeHasFootnotes) {
        cellNotes = getCellFootnotes(cellName, attributes.footnotes);
      }
      outcomeRow.cells.push(new Rm5ExportTableCell({
        textContent: rm5TbodyCells[cellName](attributes),
        sup: cellNotes || '',
        name: cellName
      }));
    }
  }
  return outcomeRow;
};
